export default {"src":"/_next/static/media/arb.8e3e2b51.svg","height":44,"width":44};